angular.module('tgaApp').service('domainService', [
  '$location',
  'envService',
  function ($location, envService) {
    const serverAddress = envService.read('serverAddress');
    const forceDomain = envService.read('forceDomain');
    const host = $location.host();
    let base = host;
    let domain = null;

    if (host.indexOf('.') >= 2) {
      const parts = host.split('.');
      domain = parts.shift();
      base = parts.join('.');
    }

    if (forceDomain) {
      domain = forceDomain;
    }

    return {
      api: serverAddress,
      base,
      domain,
    };
  },
]);
